import React from 'react';
import '../../../assignments.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ConfirmationModal from './ConfirmationModal';
import {
  faArrowRightLong,
  faChevronLeft,
  faChevronRight,
  faEraser,
  faHighlighter,
  faT
} from '@fortawesome/free-solid-svg-icons';
import ClassRoomModal from '../../../../../assets/images/ClassRoomModal.png';

import {
  useGetPreviewAssignmentInfoMutation,
  useGetQuestionDetailsMutation
} from '../../../../../features/authentication/assignmentApislice';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import QuestionDetail from '../../../components/QuestionDetail';
import Canvas from './FloatingTools';
import { faUndo } from '@fortawesome/pro-solid-svg-icons';
import HesSpinner from '../../../../../components/loadingOverlay/hesSpinner';
import { faText } from '@fortawesome/pro-regular-svg-icons';
import { faRectangle, faCircle, faArrowUpRight, faPenNib } from '@fortawesome/pro-light-svg-icons';
import QuestionPreviewTypes from '../../../../../enums/questionPreviewTypes';

const ClassRoomView = () => {
  const [getPreviewAssignmentInfo] = useGetPreviewAssignmentInfoMutation();
  const [getQuestionDetails] = useGetQuestionDetailsMutation();
  const { id } = useParams();
  const navigate = useNavigate();
  const [assignmentDetails, setAssignmentDetails] = React.useState(null);
  const [selectedQuestionId, setSelectedQuestionId] = React.useState(null);
  const [questionDetails, setQuestionDetails] = React.useState();
  const [currentPage, setCurrentPage] = React.useState(0);
  const [selectedTool, setSelectedTool] = React.useState('');
  const [activeButton, setActiveButton] = React.useState('');
  const [exitModal, setExitModal] = React.useState(false);

  const PAGE_SIZE = 30;
  const numPages = Math.ceil(assignmentDetails?.questionIds?.length / PAGE_SIZE);

  const startIndex = currentPage * PAGE_SIZE;
  const endIndex = startIndex + PAGE_SIZE;
  const pageQuestionIds = assignmentDetails?.questionIds?.slice(startIndex, endIndex);

  React.useEffect(() => {
    getPreviewHandler();
    setSelectedQuestionId(0);
    getQuestionDetailsHandler(0);
  }, []);

  function handlePrevPage() {
    setCurrentPage(currentPage - 1);
  }

  function handleNextPage() {
    setCurrentPage(currentPage + 1);
  }

  const getPreviewHandler = async () => {
    const option = { assignmentId: id };
    try {
      const response = await getPreviewAssignmentInfo(option).unwrap();
      setAssignmentDetails(response);
    } catch (error) {
      console.log(error);
    }
  };

  const getQuestionDetailsHandler = async (index) => {
    if (index === selectedQuestionId) return;

    setQuestionDetails();
    setSelectedQuestionId(index);
    let option = { Id: id, questionNo: index + 1, languageId: 0 };
    try {
      const response = await getQuestionDetails(option).unwrap();
      setQuestionDetails(response);
    } catch (error) {
      console.log(error);
    }
  };

  function squareclick() {
    if(selectedTool === 'square'){
      clearSelection();
      return;
    }
    setSelectedTool('square');
    setActiveButton('square-button');  
  }

  function handleCircle() {
    if(selectedTool === 'circle'){
      clearSelection();
      return;
    }
    setSelectedTool('circle');
    setActiveButton('circle-button');
  }

  function handleText() {
    if(selectedTool === 'text'){
      clearSelection();
      return;
    }
    setSelectedTool('text');
    setActiveButton('text-button');
  }

  function handlePointer() {
    if(selectedTool === 'arrow'){
      clearSelection();
      return;
    }
    setSelectedTool('arrow');
    setActiveButton('arrow-button');
  }

  function handlePen() {
    if(selectedTool === 'pen'){
      clearSelection();
      return;
    }
    setSelectedTool('pen');
    setActiveButton('pen-button');
  }

  function handleHighlight() {
    if(selectedTool === 'highlight'){
      clearSelection();
      return;
    }
    setSelectedTool('highlight');
    setActiveButton('highlight-button');
  }

  function handleReset() {
    setSelectedTool('erase');
    setActiveButton('');
  }

  function handleEraser() {
    if(selectedTool === 'erase-content'){
      clearSelection();
      return;
    }
    setSelectedTool('erase-content');
    setActiveButton('erase-content-button');
  }

  const exitHandler = () => {
    setExitModal(true);
  };

  const clearSelection = () => {
    setSelectedTool('');
    setActiveButton('');
  };
  return (
    <div>
      <div className="white-card mb-4 classroom-header">
        <div className="d-flex flex-column flex-md-row gap-3 justify-content-between align-items-start align-items-md-center">
          <h2 className="primary-title mb-0">
            <strong className="fw-medium">Assignment:</strong> {assignmentDetails?.assignmentName}
          </h2>
          <button onClick={exitHandler} className="btn primary-btn flex-shrink-0">
            Exit Classroom View
          </button>
        </div>
        <div className="classroom-pagination pt-3 mt-3">
          <ul className="d-flex gap-2 flex-wrap flex-lg-nowrap p-0 m-0">
            {pageQuestionIds?.map((questionId, index) => {
              const questionIndex = startIndex + index; // get the index of the question in the original array
              return (
                <li
                  key={questionIndex}
                  onClick={() => getQuestionDetailsHandler(questionIndex)}
                  className={`${selectedQuestionId == questionIndex && 'active'} cursor-pointer`}>
                  <a>{questionIndex + 1}</a>
                </li>
              );
            })}

            {numPages > 1 && (
              <>
                <li>
                  <a
                    href="#"
                    className={`btn btn-castleWhite ${currentPage === 0 && 'disabled'}`}
                    onClick={handlePrevPage}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className={`btn btn-castleWhite ${currentPage === numPages - 1 && 'disabled'}`}
                    onClick={handleNextPage}>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </a>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      {questionDetails ? (
        <div className={'white-card classroom-content overflow-auto'}>
          <Canvas
            selectedTool={selectedTool}
            selectedQuestionId={selectedQuestionId}
            Details={
              <QuestionDetail
                questionDetails={questionDetails}
                selectedQuestionId={selectedQuestionId}
                type={QuestionPreviewTypes.classRoomPreview}
                assignmentId={id}
                assignmentDetails={assignmentDetails}
              />
            }
          />
        </div>
      ) : (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: '40px' }}>
          <HesSpinner />
          <span className="ms-3">Loading results...</span>
        </div>
      )}

      <div className="floating-menu-space"></div>
      <div className="floating-menu classroom-floating">
        <div className="floating-menu-in">
          <button
            className={activeButton === 'square-button' ? 'active' : ''}
            onClick={squareclick}
            id="square-button">
            <FontAwesomeIcon icon={faRectangle} />
            Rectangle
          </button>
          <button
            className={activeButton === 'circle-button' ? 'active' : ''}
            onClick={handleCircle}>
            <FontAwesomeIcon icon={faCircle} />
            Circle
          </button>
          <button
            className={activeButton === 'arrow-button' ? 'active' : ''}
            onClick={handlePointer}>
            <FontAwesomeIcon icon={faArrowUpRight} />
            Arrow
          </button>
          <button className={activeButton === 'text-button' ? 'active' : ''} onClick={handleText}>
            <FontAwesomeIcon icon={faText} />
            Text
          </button>
          <button className={activeButton === 'pen-button' ? 'active' : ''} onClick={handlePen}>
            <FontAwesomeIcon icon={faPenNib} />
            Pen
          </button>
          <button
            className={activeButton === 'highlight-button' ? 'active' : ''}
            onClick={handleHighlight}>
            <FontAwesomeIcon icon={faHighlighter} />
            Highlighter
          </button>

          <button
            className={activeButton === 'erase-content-button' ? 'active' : ''}
            onClick={handleEraser}>
            <FontAwesomeIcon icon={faEraser} />
            Eraser
          </button>
          <button onClick={handleReset}>
            <FontAwesomeIcon icon={faUndo} />
            Reset
          </button>

          <div className="dropdown">
            <button
              className="dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              <i className="fa-solid fa-ellipsis"></i>
              More
            </button>
            <ul className="dropdown-menu">
              <li>
                <button className="dropdown-item">
                  <FontAwesomeIcon icon={faCircle} /> Circle
                </button>
              </li>
              <li>
                <button className="dropdown-item">
                  <FontAwesomeIcon icon={faArrowRightLong} /> Arrow
                </button>
              </li>
              <li>
                <button className="dropdown-item">
                  {' '}
                  <FontAwesomeIcon icon={faT} /> Text
                </button>
              </li>
              <li>
                <button className="dropdown-item">
                  {' '}
                  <FontAwesomeIcon icon={faPenNib} /> Pen
                </button>
              </li>
              <li>
                <button className="dropdown-item">
                  {' '}
                  <FontAwesomeIcon icon={faHighlighter} /> Highlighter
                </button>
              </li>
              <li>
                <button className="dropdown-item">
                  {' '}
                  <FontAwesomeIcon icon={faEraser} /> Eraser
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={exitModal}
        onClose={() => setExitModal(false)}
        contentWidth={'800px'}
        onSave={() => navigate(-1)}
        buttonPosition={'center'}
        content={'Are you sure you want to exit the classroom view?'}
        showIcon={true}
        icon={ClassRoomModal}
      />
    </div>
  );
};

export default ClassRoomView;
